import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { get, isEmpty } from 'lodash'
import { addToCartOrIncrement } from '../../actions/cart'
import { updateSelectedCategory } from '../../actions/search'

import { mapStateToPropsForItems } from '../shared/Items'

import Items from '../../components/Items'

const mapDispatchToProps = (dispatch, ownProps) => {
  const orderId = get(ownProps, 'match.params.orderId')
  const push = get(ownProps, 'history.push', () => {})

  return {
    onTapItem: (item) => {
      dispatch(addToCartOrIncrement({ itemId: item.id }))

      if (!isEmpty(item.modifierGroups)) {
        if (orderId !== undefined) {
          push(`/tab-order/${orderId}/cart`)
        } else {
          push('/tab-order/cart')
        }
      }
    },
    setSelectedCategory: (selectedCategory) => dispatch(updateSelectedCategory(selectedCategory))
  }
}

export default withRouter(connect(mapStateToPropsForItems, mapDispatchToProps)(Items))
